import React from "react";
import { listing } from "../mock";
import { Reveal } from "../hooks/useReveal";

export default function Listing() {
  return (
    <section id="listing" className="bg-paper py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <div className="mb-12 px-6 text-center md:px-10">
            <h2 className="font-sans text-xl font-light uppercase tracking-[0.3em] text-bronze-light sm:text-3xl">
              {listing.kicker}
            </h2>
            <p className="mt-4 font-sans text-[11px] uppercase tracking-[0.2em] text-ink/60 sm:text-xs">
              {listing.address} {listing.zip} · {listing.price}
            </p>
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="grid grid-cols-1 md:grid-cols-2">
            {listing.images.map((src, i) => (
              <div key={i} className="group relative overflow-hidden">
                <img
                  src={src}
                  alt={`${listing.address} view ${i + 1}`}
                  className="h-[300px] w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105 md:h-[490px]"
                />
                {/* Hover reveal: beds / baths / sq.ft. */}
                <div className="absolute inset-0 flex items-center justify-center bg-ink/0 transition-all duration-500 group-hover:bg-ink/55">
                  <span className="translate-y-2 px-4 text-center font-sans text-[12px] uppercase tracking-[0.25em] text-[#F1E6D7] opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100 sm:text-[13px]">
                    {listing.specs}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
